import * as React from "react"
export const Svg_018 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M27.771 0h3.457v4.28h-3.457V0Z" />
    <path
      fill="url(#b)"
      d="m14.337 4.526 2.994-1.729 2.14 3.706-2.994 1.729-2.14-3.706Z"
    />
    <path
      fill="url(#c)"
      d="m4.966 15.163 1.729-2.994 3.706 2.14-1.729 2.993-3.706-2.14Z"
    />
    <path fill="url(#d)" d="M2.17 25.602h4.279v3.457h-4.28v-3.457Z" />
    <path
      fill="url(#e)"
      d="m39.529 6.504 2.14-3.706 2.993 1.729-2.14 3.706-2.993-1.729Z"
    />
    <path
      fill="url(#f)"
      d="m48.598 14.308 3.706-2.14 1.728 2.994-3.706 2.14-1.728-2.994Z"
    />
    <path fill="url(#g)" d="M52.551 25.602h4.28v3.457h-4.28v-3.457Z" />
    <path
      fill="url(#h)"
      d="M49.386 27.33c0-5.299-2.06-10.285-5.802-14.038a19.758 19.758 0 0 0-14.016-5.847h-.069a19.753 19.753 0 0 0-14.037 5.802 19.752 19.752 0 0 0-5.848 14.085c0 6.059 2.74 11.694 7.339 15.43h10.819v-9.806a5.895 5.895 0 0 1-4.156-5.625 5.89 5.89 0 0 1 5.884-5.884 5.89 5.89 0 0 1 5.884 5.884 5.895 5.895 0 0 1-4.155 5.625v9.806h10.818a19.864 19.864 0 0 0 7.34-15.431Z"
    />
    <path
      fill="url(#i)"
      d="M29.5 29.758a2.427 2.427 0 1 0 0-4.854 2.427 2.427 0 0 0 0 4.854Z"
    />
    <path fill="url(#j)" d="M19.195 46.22h20.61v4.033h-20.61v-4.034Z" />
    <path
      fill="url(#k)"
      d="M29.5 59c3.24 0 5.962-2.262 6.67-5.29H22.83c.708 3.028 3.43 5.29 6.67 5.29Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={28.571}
        x2={30.765}
        y1={0.642}
        y2={3.51}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={15.351}
        x2={18.684}
        y1={4.682}
        y2={6.069}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={5.922}
        x2={9.502}
        y1={14.791}
        y2={14.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={3.159}
        x2={4.626}
        y1={26.121}
        y2={29.061}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={40.472}
        x2={43.752}
        y1={5.907}
        y2={6.106}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={49.714}
        x2={52.455}
        y1={14.262}
        y2={16.075}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={53.541}
        x2={55.008}
        y1={26.121}
        y2={29.061}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={18.811}
        x2={34.633}
        y1={12.742}
        y2={41.578}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={28.195}
        x2={30.501}
        y1={25.632}
        y2={29.364}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={23.961}
        x2={24.472}
        y1={46.825}
        y2={51.047}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={25.915}
        x2={27.215}
        y1={54.503}
        y2={59.804}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)